"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  padding: 0 0 1rem;\n  border-bottom: 2px solid ", ";\n"])), function (props) {
  return props.theme.colorBorder;
});

var StyledNumber = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 0 30px;\n  width: 30px;\n  height: 30px;\n  max-width: 30px;\n  max-height: 30px;\n  margin-top: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  border-radius: 50%;\n  color: ", ";\n  background: ", ";\n"])), function (props) {
  return props.theme.colorAccentText;
}, function (props) {
  return props.theme.colorAccent;
});

var StyledText = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  margin-top: 0.3rem;\n  margin-left: 0.75rem;\n  line-height: 1.35;\n  font-size: 0.75rem;\n  font-weight: 400;\n"])));

var ContestBannerHelpList = function ContestBannerHelpList(props) {
  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      translations = _useSelector.translations;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {
        children: "1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: process.env.REACT_APP_PICKS_HOW_TO_PLAY_1 || translations.howToPlayStep1
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {
        children: "2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: process.env.REACT_APP_PICKS_HOW_TO_PLAY_2 || translations.howToPlayStep2
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {
        children: "3"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: translations.howToPlayStep3
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {
        children: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: translations.howToPlayStep4
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {
        children: "5"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: translations.howToPlayStep5
      })]
    })]
  });
};

var _default = ContestBannerHelpList;
exports.default = _default;